export const CoinHelper = {
  feeUnit(currency: string) {
    let unit = "";
    switch (currency) {
      case "USDT": {
        unit = "TRX";
        break;
      }
    }
    return unit;
  },
};
